
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/privacyPolicy",
      function () {
        return require("private-next-pages/legal/privacyPolicy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/privacyPolicy"])
      });
    }
  